import { isKnowledgeQuiz, isReflection, projectHasBadge } from 'helpers/Step'
import { useEffect } from 'react'
import {
  createProgress,
  fetchProjectProgress,
  updateProgress,
} from 'redux/actions/ProgressActions'
import { setProjectStep } from 'redux/actions/ProjectActions'

const useProgress = ({
  currentProjectSlug,
  currentStepPosition,
  dispatch,
  i18n,
  session,
  authentication,
  slug,
  project,
  projectFetched,
  projectProgress,
}) => {
  const token = authentication?.user ? authentication.user.access_token : null

  // Fetch progress on project/locale/session/user change
  useEffect(() => {
    dispatch(fetchProjectProgress(i18n.language, token, slug, session))
  }, [dispatch, i18n.language, session, token, slug])

  useEffect(() => {
    if (
      projectProgress.loading ||
      projectProgress.slug !== slug ||
      currentStepPosition
    ) {
      return
    }
    if (
      projectProgress.currentStep &&
      projectProgress.currentStep !== currentStepPosition
    ) {
      dispatch(setProjectStep(projectProgress.currentStep))
    }
  }, [i18n.language, currentStepPosition, projectProgress, slug, dispatch])

  // Save progress if needed
  useEffect(() => {
    if (
      projectProgress.loading ||
      projectProgress.sending ||
      projectProgress.sent
    ) {
      return
    }

    const autoProgressExclusions =
      project.steps?.[currentStepPosition] &&
      (isKnowledgeQuiz(project.steps[currentStepPosition]) ||
        (isReflection(project.steps[currentStepPosition]) &&
          projectHasBadge(project)))

    if (
      projectFetched &&
      currentProjectSlug === slug &&
      !autoProgressExclusions
    ) {
      progressDispatch({
        dispatch,
        project,
        projectProgress,
        locale: i18n.language,
        slug,
        currentStepPosition,
        session,
        token,
      })
    }
  }, [
    currentStepPosition,
    dispatch,
    i18n.language,
    project,
    projectFetched,
    projectProgress,
    session,
    currentProjectSlug,
    slug,
    authentication,
    token,
  ])
}

const progressDispatch = ({
  dispatch,
  project,
  projectProgress,
  locale,
  slug,
  currentStepPosition,
  session,
  token,
}) => {
  const currentStep = project.steps[currentStepPosition]
  const completion = currentStep && currentStep.completion
  if (projectProgress.slug) {
    dispatch(
      updateProgress(
        locale,
        token,
        project.id,
        slug,
        currentStepPosition,
        completion,
        session
      )
    )
  } else {
    dispatch(
      createProgress(
        locale,
        token,
        project.id,
        slug,
        currentStepPosition,
        completion,
        session
      )
    )
  }
}

export { useProgress }
